import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from '@proman/rxjs-common';

import { AuthService } from '../services/auth.service';
import { completeJsonRequest, getJsonRequests, pendingReqIncr } from '../store/utils';

const FILE_UPLOAD_URLS = [
    'api/file/upload',
    'read_from_file',
    '/import',
    '/save_certificate',
    '/sodra/imports/identify_file',
];

@Injectable({
    providedIn: 'root',
})
export class HttpRequestInterceptor implements HttpInterceptor {
    private Auth = inject(AuthService);
    private store = inject(Store);

    jsonReqs: string[];

    constructor() {
        this.store.select(getJsonRequests).subscribe((val) => {
            this.jsonReqs = val;
        });
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.store.dispatch(pendingReqIncr());

        if (!FILE_UPLOAD_URLS.some((url) => req.url.includes(url))) {
            if (req.url.includes('doc-summary-')) {
                //Kuo maziau headeriu kad nebutu preflight requesto
                req = req.clone({
                    setHeaders: {},
                });
            } else {
                req = req.clone({
                    setHeaders: {
                        Authorization: this.Auth.getToken() || '',
                        Session: this.Auth.getSessionToken() || '',
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                });
            }
        } else {
            req = req.clone({
                setHeaders: {
                    Authorization: this.Auth.getToken() || '',
                    Session: this.Auth.getSessionToken() || '',
                },
            });
        }

        if (this.jsonReqs.includes(req.url)) {
            req = req.clone({
                setHeaders: {
                    'Content-Type': 'application/json',
                },
            });

            this.store.dispatch(completeJsonRequest({ payload: req.url }));
        }

        return next.handle(req);
    }
}
